import fetch from 'auth/GenericFetchInterceptorV5';

const PianoContiService = {};

PianoContiService.getAll = function (companyDocumentId) {
    return fetch({
        url: `/api/chart-of-accounts?filters[company][documentId][$eq]=${companyDocumentId}&pagination[limit]=3000&sort=codice:asc`,
        method: 'GET',
    });
};

PianoContiService.create = function (data) {
    return fetch({
        url: `/api/chart-of-accounts`,
        method: 'POST',
        data: { data },
    });
};

PianoContiService.update = function (documentId, data) {
    return fetch({
        url: `/api/chart-of-accounts/${documentId}`,
        method: 'PUT',
        data: { data },
    });
};

PianoContiService.inizializzaDefault = function (companyDocumentId) {
    return fetch({
        url: `/api/chart-of-accounts/initialize-default`,
        method: 'POST',
        data: { companyDocumentId },
    });
};

PianoContiService.resetStandard = function (companyDocumentId) {
    return fetch({
        url: `/api/chart-of-accounts/reset-standard`,
        method: 'POST',
        data: { companyDocumentId },
    });
};

PianoContiService.deleteAll = function (companyDocumentId) {
    return fetch({
        url: `/api/chart-of-accounts/clear-all`,
        method: 'POST',
        data: { companyDocumentId },
    });
};

export default PianoContiService;
